import { defineComponent as _defineComponent } from 'vue'
import LandsideFooterOld from 'vuecomponents/LandsideFooterOld.vue'
import ContactForm from 'vuecomponents/contact_form.vue'
import ContactHeader from 'vuecomponents/contact_header.vue'
import ContactNav from 'vuecomponents/contact_nav.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'contact_app',
  setup(__props) {


return { __sfc: true,LandsideFooterOld, ContactForm, ContactHeader, ContactNav }
}

})